module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="league-regeneration-header">\n	<h4>Customise your comp settings</h4>\n	<ul>\n		<li class="done">\n			Step 1 <br/> Select Comp\n		</li>\n		<li class="active">\n			Step 2 <br/> Settings\n		</li>\n		<li>\n			Step 3 <br/> Send Invites\n		</li>\n		<li>\n			Step 4 <br/> Confirm\n		</li>\n	</ul>\n</div>';
}
return __p;
};
